import React, { Component } from 'react';
import PropTypes from 'prop-types';
// common components
import PageHeader from './../../common/PageHeader/PageHeader';
import Modal from './../../common/Modal/Modal';
import Pagination from './../../common/Pagination/Pagination';
// components
import ManageCourse from './ManageCourse/ManageCourse';
import CourseList from './CourseList/CourseList';

class Course extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalOpen: false,
			title: '',
			currentId: '',
			name: '',
			description: '',
			clonedCourseName: '',
		}
		this.manageCourse = this.manageCourse.bind(this);
		this.courseModule = this.courseModule.bind(this);
		this.courseUpdate = this.courseUpdate.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		const { courseContext } = this.props;
		courseContext.getCourseList(1, 25);
    }

    componentWillUnMount() {
    	this.props.courseContext.clearCourseList();
    	this.props.commonContext.updatePagination();
		this.props.commonContext.updateLoaderMsg();
	}

	componentWillReceiveProps(nextProps) {
		const { title } = this.state;
		const { courseDetails: {name, description} } = nextProps.courseContext;
		const { courseDetails } = this.props.courseContext;

		if ( title === 'edit') {
			this.setState({ name, description });
		}
		if (title === 'clone') {
			this.setState({ name });
		}
	}

	// pagination
	onChangePage = (curr_page, size) => {
		this.props.courseContext.getCourseList(curr_page, size);
	}

	// manage Modal
	manageCourse(value,title=null,id=null) {
		const { courseContext } = this.props;
		if(value) {
			if(title !== 'add') {
				this.setState({ currentId: id });
				if(title === 'edit'|| title === 'clone') {
					courseContext.getCourseDetails(id);
				}
			}
		} else {
			this.setState({	currentId: '', name: '', description: '', clonedCourseName: ''});
			courseContext.clearCourseDetails();
		}
        this.setState({ modalOpen: value, title });
	};

	onChange = (e) => {
		this.setState({[e.target.name]: e.target.value});
	}

	// Modal action
	courseUpdate() {
		const { title, currentId, name, description, clonedCourseName } = this.state;
		const { deleteCourse, cloneCourse, activateClonedCourse, updateCourseDetails, addCourseDetails } = this.props.courseContext;

		if(title === 'delete') {
			deleteCourse(currentId);
		} else if (title === 'activate') {
			// console.log("Cloned course activated",currentId);
			activateClonedCourse(currentId);
		}else if (title === 'clone') {
			let data = {
				course_id: currentId,name: clonedCourseName
			}
			console.log("cloned data",data);
			cloneCourse(data);
		}else if (title === 'edit') {
			let data = {
				id: currentId, name, description
			}
			updateCourseDetails(data);
		} else if (title === 'add') {
			let data = { 
				name, description 
			}
			addCourseDetails(data);
		}
	}

	// course Module
	courseModule(course_id) {
		const { history } = this.props;
		history.push(`${this.props.match.url}/cm/${course_id}`);
	}

	render () {
		const { courseList, courseDetails } = this.props.courseContext;
		const { pagination } = this.props.commonContext;
		const { name, description, clonedCourseName, modalOpen, title} = this.state;
		const disabled = name === '' || (name === courseDetails.name && description === courseDetails.description);
		const cloneDisable = name === '' || (name === courseDetails.name && clonedCourseName ==='')

		return (
			<div className='Course'>
				<PageHeader
					title='courses'
					btnText='course'                    					
					onAdd={() => this.manageCourse(true,'add')}
				/>
				
				<CourseList
					courseModule={this.courseModule}
					manageCourse={this.manageCourse}
					courseList={courseList}
				/>
				{pagination && pagination.totalElements > 0 &&
					<Pagination
						totalPage={pagination.totalPages}
						onChangePage={this.onChangePage}
						count={pagination.totalElements}
						first={pagination.first}
						last={pagination.last}
					/>
				}

				{/* Add, Edit, and delete Course Modal */}
				{modalOpen && 
					<Modal
						modalOpen={modalOpen}
						toggleModal={this.manageCourse}
						title={`${title} Course`}
						confirm={this.courseUpdate}
						disabled={(title !== 'delete')&&(title !== 'activate')&&((title==='clone')?cloneDisable:disabled)}
					>
						<ManageCourse 
							onDelete={title === 'delete'}
							onClone={title === 'clone'}
							onActivate={title === 'activate'}
							onChange={(e)=>this.onChange(e)}
							value={{
								name,
								description,
								clonedCourseName
							}}
						/>
					</Modal>
				}
			</div>
		);
	}
}


Course.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object),
    courseContext: PropTypes.instanceOf(Object)
};

Course.defaultProps = {
    history: {},
    match: {},
    courseContext: {}
};

export default Course;



// WEBPACK FOOTER //
// ./components/Course/Course.js